import { Typography } from 'seagull';
import NetTermsDropdown from "../../../../components/NetTermsDropdown/NetTermsDropdown";
import pluralize from "../../../../utils/pluralize";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
export default function NetTermsCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const onClick = () => onOpenModal({
    width: '500px',
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Number of days until the payment is due',
        testId: 'edit-net-terms-modal',
        content: /*#__PURE__*/_jsx(NetTermsDropdown, {
          isReadOnly: false,
          netTerms: draft.netTerms(),
          onChange: netTerms => setDraft(draft.setNetTerms(netTerms)),
          testId: "net-terms-".concat(index, "-dropdown"),
          dropdownWidth: 220
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testId: "edit-net-terms-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      testId: "net-terms-".concat(index),
      children: draft.netTerms() === 0 ? 'Upon receipt of invoice' : pluralize('day', draft.netTerms(), true)
    })
  });
}